export const sinatraOrigin
  = process.env.REACT_APP_SINATRA_ORIGIN === '/'
    ? window.location.origin
    : process.env.REACT_APP_SINATRA_ORIGIN;
export const keycloakConfigOrigin = (() => {
  // In development, the Keycloak config files are served by the CRA development server.
  // In production, they're served by Sinatra.
  if (process.env.NODE_ENV === 'development') {
    return '';
  }
  return process.env.REACT_APP_SINATRA_ORIGIN;

})();
export const shouldDisablePrometheus = process.env.REACT_APP_DISABLE_PROMETHEUS === 'true';
export const shouldDisableLogs = process.env.REACT_APP_DISABLE_LOGS === 'true';
export const modelsIndexPollInterval = (() => {
  if (process.env.REACT_APP_MODELS_INDEX_POLL_INTERVAL) {
    return parseInt(process.env.REACT_APP_MODELS_INDEX_POLL_INTERVAL, 10);
  } 
  return 10000;
  
})();
export const modelDetailTimeRangePollInterval = (() => {
  if (process.env.REACT_APP_MODEL_DETAIL_TIME_RANGE_POLL_INTERVAL) {
    return parseInt(process.env.REACT_APP_MODEL_DETAIL_TIME_RANGE_POLL_INTERVAL, 10);
  } 
  return 1000;
  
})();
